/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sets: NonNullable<unknown>, reps: NonNullable<unknown> }} Draft_TargetsInputs */

const en_us2_draft_targets = /** @type {(inputs: Draft_TargetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.reps}`)
};

const pt_br2_draft_targets = /** @type {(inputs: Draft_TargetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.reps}`)
};

const es_419_draft_targets = /** @type {(inputs: Draft_TargetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.reps}`)
};

const pt_pt2_draft_targets = /** @type {(inputs: Draft_TargetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.reps}`)
};

const fr_fr2_draft_targets = /** @type {(inputs: Draft_TargetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.reps}`)
};

const de_de2_draft_targets = /** @type {(inputs: Draft_TargetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.reps}`)
};

const it_it2_draft_targets = /** @type {(inputs: Draft_TargetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.reps}`)
};

/**
* | output |
* | --- |
* | "{sets} × {reps}" |
*
* @param {Draft_TargetsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_targets = /** @type {((inputs: Draft_TargetsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_TargetsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_targets(inputs)
	if (locale === "es-419") return es_419_draft_targets(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_targets(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_targets(inputs)
	if (locale === "de-DE") return de_de2_draft_targets(inputs)
	if (locale === "it-IT") return it_it2_draft_targets(inputs)
	return en_us2_draft_targets(inputs)
});
export { draft_targets as "draft.targets" }